export default __webpack_public_path__ + "static/media/trr-food-pastry-13.3aa10ba5.png";